module.exports = __webpack_public_path__ + "static/port-19c69457797841e3f07cf29e9592c99e.jpg";